if (!customElements.get('lazy-video')) {
  class LazyVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.mq = window.matchMedia('(min-width: 750px)');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.setPoster();
      this.mq.addEventListener('change', () => {
        this.setPoster();
        if (this.loaded) this.load(true);
      });
      this.observer = new IntersectionObserver(
        (entries) => {
          this.inView = entries[entries.length - 1].isIntersecting;
          if (this.inView && !this.loaded) this.load();
          this.toggle();
        },
        { rootMargin: '200px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    current(key) {
      return this.dataset[`${key}${this.mq.matches ? 'Desktop' : 'Mobile'}`] || '';
    }

    setPoster() {
      const poster = this.current('poster');
      if (poster) this.video.poster = poster;
    }

    load(force) {
      const src = this.current('src');
      if (!src || (this.video.src === src && !force)) return;
      this.video.src = src;
      this.video.load();
      this.loaded = true;
      this.toggle();
    }

    toggle() {
      if (this.inView && !this.reduce.matches) {
        this.video.play().catch(() => {});
      } else {
        this.video.pause();
      }
    }
  }
  customElements.define('lazy-video', LazyVideo);
}
